import React from 'react';
import { isPast, differenceInCalendarDays } from 'helpers/dates';
import { StringHelpers, SystemText } from '@salesperformanceint/e4shared';
import Panel from 'components/general/panel';
import FocusTile from 'views/user/1-2-1s/components/performanceDashboard/components/focusTile';
import { useSelector } from 'react-redux';

export const NextReview = ({ focus, data, setShow }) => {
    if (!data) return null;

    const { user } = useSelector(state => state.user);

    const reviewDaysAgo = differenceInCalendarDays(data.scheduled, new Date());

    const colour = reviewDaysAgo < 0 ? 'danger' : data.completed ? 'information' : 'warning';

    data.manager = data.participants?.indexOf('M') >= 0;

    let message = '';

    if (data.completed) {
        if (data.manager && !data.manager_Completed) {
            // User completed, awaiting manager completion
            message = SystemText('Home/Widgets/WhatsHappening/NextReview/AwaitingManager');
        } else if (data.manager && user.reviewViaSitdown) {
            // Both completed - waiting actual review
            message = SystemText('Home/Widgets/WhatsHappening/NextReview/AwaitingReview');
        } else {
            // user completed - manager not involved
            // SHOULD NOT HIT AS IF NO MANAGER, USER COMPLETING COMPLETES REVIEW
        }
    } else {
        if (reviewDaysAgo === 0) {
            // User not completed, today
            message = SystemText('Home/Widgets/WhatsHappening/NextReview/Today');
        } else if (isPast(data.scheduled)) {
            // User not completed = overdue
            message = SystemText('Home/Widgets/WhatsHappening/NextReview/Overdue', reviewDaysAgo * -1);
        } else {
            // User not completed = still time
            message = SystemText('Home/Widgets/WhatsHappening/NextReview/Upcoming', reviewDaysAgo);
        }
    }

    const url = `/develop/reviews/${data.profile_Id}`;

    if (focus)
        return (
            <FocusTile
                tileType="review"
                colour={colour === 'danger' ? 'red' : 'purple'}
                icon="fa-list-check"
                message={message}
                url={url}
                setShow={setShow}
                date={data.scheduled}
                buttonText={data.started ? 'Continue' : 'Start'}
            />
        );

    return <Panel colour={colour} icon="calendar" message={message} url={url} />;
};

export default NextReview;
